<template>
    <v-autocomplete
        :value="value"
        :items="itens"
        :search-input.sync="busca"
        :loading="carregando"
        :label="label"
        :disabled="disabled"
        :hint="hint"
        :persistent-hint="!!hint"
        item-value="id"
        item-text="texto"
        placeholder="Digite para buscar"
        no-filter
        hide-no-data
        clearable
        outlined
        dense
        @change="selecionar"
    />
</template>

<script>
export default {
    name: 'BuscaRemota',

    props: {
        value: { type: [Number, String], default: null },
        tipo: { type: String, required: true }, // 'empresas' | 'contatos'
        label: { type: String, default: '' },
        inicial: { type: Object, default: null }, // { id, texto }
        disabled: { type: Boolean, default: false },
        hint: { type: String, default: '' },
    },

    data: () => ({
        busca: null,
        resultados: [],
        selecionado: null,
        carregando: false,
        timer: null,
    }),

    computed: {
        itens() {
            const lista = this.selecionado ? [this.selecionado] : [];

            this.resultados.forEach(item => {
                if (!lista.some(i => i.id === item.id)) lista.push(item);
            });

            return lista;
        },
    },

    watch: {
        inicial: {
            immediate: true,
            handler(item) {
                this.selecionado = item && item.id ? item : null;
                this.resultados = [];
            },
        },

        busca(texto) {
            clearTimeout(this.timer);

            if (!texto || texto.trim().length < 2 || (this.selecionado && texto === this.selecionado.texto)) {
                return;
            }

            this.timer = setTimeout(() => this.buscar(texto.trim()), 350);
        },
    },

    beforeDestroy() {
        clearTimeout(this.timer);
    },

    methods: {
        async buscar(q) {
            this.carregando = true;

            try {
                const { data } = await this.$http.get(`gestao/indicacoes/${this.tipo}`, { params: { q } });
                this.resultados = (data.data || []).map(this.paraItem);
            } catch (e) {
                this.resultados = [];
            } finally {
                this.carregando = false;
            }
        },

        paraItem(registro) {
            if (this.tipo === 'contatos') {
                return { id: registro.id, texto: `${registro.nome} · ${registro.whatsapp || 'sem WhatsApp'} (lead #${registro.id})` };
            }

            return { id: registro.id, texto: `#${registro.id} ${registro.fantasia || registro.razao_social || ''}` };
        },

        selecionar(id) {
            this.selecionado = this.itens.find(i => i.id === id) || null;
            this.$emit('input', id || null);
        },
    },
};
</script>
